/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IGetAllSuggestionsMessage extends IMessage {
	documentId: string;
}

export default class GetAllSuggestionsMessage extends Message {
	public static readonly TYPE: string = '102';

	public static readonly READABLE_TYPE_NAME: string = 'getAllSuggestions';

	public static readonly DESCRIPTOR_NAME: string = 'TrackChangesGetAllSuggestionMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			documentId: {
				type: 'string',
				id: 1
			}
		}
	};

	public constructor( public readonly documentId: string ) {
		super();
	}

	public toJSON(): IGetAllSuggestionsMessage {
		return {
			documentId: this.documentId
		};
	}

	public static fromJSON( object: IGetAllSuggestionsMessage ): GetAllSuggestionsMessage {
		return new GetAllSuggestionsMessage( object.documentId );
	}
}
